import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

//Event Contarct_List
export const getEventContractList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.MANAGE_EVENT_CONTRACT_LIST_API
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Event_Contarct_By_Id
export const getEventContractById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_EVENT_CONTRACT_BY_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


// Event_Contarct_By_EVENT_ID
export const getEventContractByEventId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_CONTRACT_BY_EVENT_ID}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//Event_Contract_Update
export const updateEventContract = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.MANAGE_EVENT_CONTRACT_UPDATE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Event_Contract_ADD
export const addEventContract = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.MANAGE_EVENT_CONTRACT_ADD_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


export const setContractId = (id) => {
  localStorage.setItem("contractId", id);
};

export const getContractId = () => {
  const id = localStorage.getItem("contractId");
  if (id !== null && id !== undefined) {
    return id;
  } else {
    return null;
  }
};
export const removeContractId = () => {
  localStorage.removeItem("contractId");
};




// Event_Contarct_for_Final Email
export const getEventContractFinalEmailAdd = async (EventId, ContractType) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
     // `${apiendpoints.MANAGE_EVENT_CONTRACT_FORFINAlEMAILADD_API}?EventId=${EventId}`
         `${apiendpoints.MANAGE_EVENT_CONTRACT_FORFINAlEMAILADD_API}?EventId=${EventId}&ContractType=${ContractType}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};


// Event_Contarct_for_Terms And Conitions
export const getEventContractTermAndConditionAdd = async (EventId, ContractType) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_EVENT_CONTRACT_FOR_Term_And_Condition_API}?EventId=${EventId}&ContractType=${ContractType}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};



// Event_Contarct_for_Handbooks
export const getEventContractHandBooks = async (EventId,ContractType) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_EVENT_CONTRACT_FOR_HandBooks_API}?EventId=${EventId}&ContractType=${ContractType}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};